import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { DynamicTaskResponse } from '@/types/apps/dynamic-task.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface DynamicTaskGraphQLServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type DynamicTaskListResponse = GqlListResponse<DynamicTaskResponse>;

export class DynamicTaskGraphQLService
    extends BaseService
    implements DynamicTaskGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'taskTemplate';
    }

    public getFields(): Record<string, any> {
        return {
            id: true,
            code: true,
            name: true,
            endAt: true,
            startAt: true,
            taskCheckType: {
                name: true,
            },
            ticket: {
                customer: {
                    id: true,
                    name: true,
                    devices: {
                        name: true,
                        id: true,
                    },
                },
            },
            assignee: {
                id: true,
                fullname: true,
            },
        };
    }

    public async index(query: string): Promise<DynamicTaskListResponse> {
        return this.fetchGqlList(query, this.getEntityName());
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('dynamicTask', {
            userId: this.getQueryById(),
        });
    }
}
